/* InduCrayones landing — comportamiento compartido */
(function(){
  'use strict';

  function initReveal(scope){
    var els = (scope || document).querySelectorAll('.ic .rev:not(.ic-rev-ready)');
    if (!('IntersectionObserver' in window)){ els.forEach(function(el){el.classList.add('in','ic-rev-ready');}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('in'); io.unobserve(x.target); } });
    }, {threshold:.08});
    els.forEach(function(el){ el.classList.add('ic-rev-ready'); io.observe(el); });
  }

  function initNav(){
    var nav = document.querySelector('.ic-nav');
    if (!nav || nav.dataset.icBound) return;
    nav.dataset.icBound = '1';
    var last = 0;
    window.addEventListener('scroll', function(){
      var y = window.scrollY;
      nav.classList.toggle('sc', y > 20);
      nav.classList.toggle('dn', y > last + 8 && y > 80);
      if (y < last - 8 || y <= 80) nav.classList.remove('dn');
      last = y;
    }, {passive:true});
  }

  function initChalkBg(){
    var cc = document.querySelector('.ic-cc');
    if (!cc || cc.dataset.icBound) return;
    cc.dataset.icBound = '1';
    var ctx = cc.getContext('2d'), W, H;
    function mkP(x0,w){ var p=[],s=Math.ceil(H/50),x=x0; for(var i=0;i<=s;i++){x+=(Math.random()-.48)*w;x=Math.max(10,Math.min(W-10,x));p.push({x:x,y:(i/s)*H});} return p; }
    function drw(p,w,op){ if(p.length<2)return; ctx.save();ctx.globalAlpha=op;ctx.lineCap='round';ctx.lineJoin='round';ctx.beginPath();ctx.moveTo(p[0].x,p[0].y);
      for(var i=1;i<p.length;i++){var cp={x:(p[i-1].x+p[i].x)/2,y:(p[i-1].y+p[i].y)/2};ctx.quadraticCurveTo(p[i-1].x,p[i-1].y,cp.x,cp.y);}
      ctx.strokeStyle='#F2BE00';ctx.lineWidth=w;ctx.stroke();
      for(var i2=0;i2<p.length-1;i2++)for(var j=0;j<Math.floor(w*2.2);j++){var t=Math.random(),px=p[i2].x+(p[i2+1].x-p[i2].x)*t+(Math.random()-.5)*w*1.6,py=p[i2].y+(p[i2+1].y-p[i2].y)*t+(Math.random()-.5)*w*.6;ctx.beginPath();ctx.arc(px,py,Math.random()*w*.24+.3,0,Math.PI*2);ctx.fillStyle='#F2BE00';ctx.globalAlpha=op*(Math.random()*.55+.08);ctx.fill();}
      ctx.restore(); }
    function init(){ W=cc.width=window.innerWidth;H=cc.height=Math.max(document.body.scrollHeight,window.innerHeight);ctx.clearRect(0,0,W,H);
      drw(mkP(W*.08,55),4.5,.26);drw(mkP(W*.92,50),3.0,.16);drw(mkP(W*.5,90),1.5,.065);drw(mkP(W*.02,18),1.1,.09);drw(mkP(W*.98,18),1.0,.08); }
    window.addEventListener('resize',function(){clearTimeout(window._icrt);window._icrt=setTimeout(init,150);});
    init();setTimeout(init,700);
  }

  function initChalkTrail(){
    var tc = document.querySelector('.ic-chalk');
    if (!tc || tc.dataset.icBound) return;
    if (window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse), (max-width: 768px)').matches){ tc.style.display='none'; return; }
    tc.dataset.icBound = '1';
    var ctx=tc.getContext('2d'),pts=[],raf=null;
    var TTL = 1000;
    function rs(){tc.width=window.innerWidth;tc.height=window.innerHeight;}
    function gp(e){return{x:e.clientX,y:e.clientY,t:performance.now()};}
    function dt(){
      var now=performance.now();
      while(pts.length && now - pts[0].t > TTL) pts.shift();
      ctx.clearRect(0,0,tc.width,tc.height);
      if(pts.length<2){ if(pts.length===0) raf=null; else raf=requestAnimationFrame(dt); return; }
      ctx.save();ctx.lineCap='round';ctx.lineJoin='round';ctx.strokeStyle='#F2BE00';ctx.fillStyle='#F2BE00';
      for(var i=1;i<pts.length;i++){
        var a = pts[i-1], b = pts[i];
        var age = (now - a.t) / TTL;
        var op = Math.max(0, 1 - age);
        ctx.globalAlpha = .88 * op;
        ctx.lineWidth = 5.5 * (1 - age*.4);
        ctx.beginPath();ctx.moveTo(a.x,a.y);
        var cp={x:(a.x+b.x)/2,y:(a.y+b.y)/2};
        ctx.quadraticCurveTo(a.x,a.y,cp.x,cp.y);ctx.stroke();
        for(var j=0;j<10;j++){
          var t2=Math.random();
          var px2=a.x+(b.x-a.x)*t2+(Math.random()-.5)*8;
          var py2=a.y+(b.y-a.y)*t2+(Math.random()-.5)*3;
          ctx.globalAlpha = (Math.random()*.5+.12) * op;
          ctx.beginPath();ctx.arc(px2,py2,Math.random()*1.4+.3,0,Math.PI*2);ctx.fill();
        }
      }
      ctx.restore();
      raf = requestAnimationFrame(dt);
    }
    window.addEventListener('mousemove',function(e){pts.push(gp(e));if(!raf)raf=requestAnimationFrame(dt);});
    window.addEventListener('resize',rs);rs();
  }

  function initBuyBox(box){
    if (box.dataset.icBound) return;
    var sid = box.getAttribute('data-sid');
    var varEl = document.getElementById('ic-variants-' + sid);
    var idxEl = document.getElementById('ic-optidx-' + sid);
    if (!varEl || !idxEl) return;
    box.dataset.icBound = '1';
    var variants = JSON.parse(varEl.textContent);
    var idx = JSON.parse(idxEl.textContent);
    var buyLabel = box.getAttribute('data-buylabel') || 'Agregar al carrito';
    var state = { color:null, pack:null, qty:1 };
    var colorBtns = box.querySelectorAll('.csw');
    var packItems = box.querySelectorAll('.pack-item');
    var bulkItem = box.querySelector('.pack-item.bulk');
    var qtyInput = box.querySelector('.qty-inp');
    var qtyTotalEl = box.querySelector('.qty-total-amt');
    var form = box.querySelector('.ic-prod-form');
    var qtyHidden = null;
    if (form){
      qtyHidden = document.createElement('input');
      qtyHidden.type = 'hidden'; qtyHidden.name = 'quantity'; qtyHidden.value = '1';
      form.appendChild(qtyHidden);
    }
    var bulkMinVal = 50;
    if (bulkItem){
      var pre = (bulkItem.getAttribute('data-value') || '').split('+')[0];
      var m = pre.match(/\d+/g);
      if (m) bulkMinVal = parseInt(m[m.length-1], 10);
      if (qtyInput){ qtyInput.value = bulkMinVal; qtyInput.setAttribute('min', bulkMinVal); }
    }
    var bulkUnit = bulkItem ? parseInt(bulkItem.getAttribute('data-unit-price') || '0', 10) : 0;
    function fmtCOP(cents){ var n = Math.round(cents/100); return '$' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
    if (colorBtns.length){ state.color = colorBtns[0].getAttribute('data-value'); }
    if (packItems.length){ state.pack = packItems[0].getAttribute('data-value'); }
    if (bulkItem && bulkItem.classList.contains('on')) state.qty = bulkMinVal;

    function findVariant(){
      return variants.find(function(v){
        var ok = true;
        if (idx.color > 0 && state.color !== null){ ok = ok && (v.options[idx.color-1] === state.color); }
        if (idx.pack > 0 && state.pack !== null){ ok = ok && (v.options[idx.pack-1] === state.pack); }
        return ok;
      });
    }
    function update(){
      var idInput = box.querySelector('.ic-varid');
      var btn = box.querySelector('.buy-btn');
      if (!idInput || !btn) return;

      // open pack (accordion)
      var openPack = box.querySelector('.pack-item[open]');
      var isMixerPack = openPack && openPack.querySelector('.pack-mix');

      if (isMixerPack){
        var packVal = openPack.getAttribute('data-value');
        var isBulkMix = openPack.classList.contains('bulk');
        var maxQ = getPackMax(openPack);
        var cur = (box._icMixState && box._icMixState[packVal]) ? Object.keys(box._icMixState[packVal]).reduce(function(a,k){return a + (box._icMixState[packVal][k]||0);},0) : 0;
        var firstColor = null;
        if (box._icMixState && box._icMixState[packVal]){
          for (var k in box._icMixState[packVal]){ if (box._icMixState[packVal][k] > 0){ firstColor = k; break; } }
        }
        var base = null;
        if (firstColor){
          base = variants.find(function(v){
            var okP = idx.pack > 0 ? v.options[idx.pack-1] === packVal : true;
            var okC = idx.color > 0 ? v.options[idx.color-1] === firstColor : true;
            return okP && okC && v.available;
          });
        }
        if (!base){
          base = variants.find(function(v){
            var okP = idx.pack > 0 ? v.options[idx.pack-1] === packVal : true;
            return okP && v.available;
          });
        }
        if (base){ idInput.value = base.id; }

        if (isBulkMix && maxQ < 50){
          btn.setAttribute('disabled','disabled'); btn.textContent = 'Mínimo 50 cajas';
        } else if (cur === 0){
          btn.setAttribute('disabled','disabled'); btn.textContent = 'Elige los colores';
        } else if (cur < maxQ){
          btn.setAttribute('disabled','disabled'); btn.textContent = 'Faltan ' + (maxQ-cur) + ' por elegir';
        } else if (cur > maxQ){
          btn.setAttribute('disabled','disabled'); btn.textContent = 'Excede el pack';
        } else {
          btn.removeAttribute('disabled'); btn.textContent = buyLabel;
        }

        if (qtyHidden){ qtyHidden.value = isBulkMix ? String(Math.max(1, cur)) : '1'; }
        if (qtyTotalEl && bulkUnit && isBulkMix){ qtyTotalEl.textContent = fmtCOP(bulkUnit * Math.max(0, cur)); }
        return;
      }

      var v = findVariant();
      if (v){
        idInput.value = v.id;
        if (v.available){ btn.removeAttribute('disabled'); btn.textContent = buyLabel; }
        else { btn.setAttribute('disabled','disabled'); btn.textContent = 'Agotado'; }
      } else { btn.setAttribute('disabled','disabled'); btn.textContent = 'No disponible'; }
      var bulkOn = bulkItem && (bulkItem.open || bulkItem.classList.contains('on'));
      if (bulkOn && state.qty < bulkMinVal){
        btn.setAttribute('disabled','disabled');
        btn.textContent = 'Mínimo ' + bulkMinVal + ' cajas';
      }
      if (qtyHidden){ qtyHidden.value = bulkOn ? Math.max(1, state.qty) : 1; }
      if (qtyTotalEl && bulkUnit){ qtyTotalEl.textContent = fmtCOP(bulkUnit * Math.max(0, state.qty)); }
    }

    // intercept form submit to inject color distribution as line item properties
    if (form){
      form.addEventListener('submit', function(ev){
        var openPack = box.querySelector('.pack-item[open]');
        if (!openPack || !openPack.querySelector('.pack-mix')) return;
        var packVal = openPack.getAttribute('data-value');
        var st = (box._icMixState && box._icMixState[packVal]) || {};
        // remove old injected props
        form.querySelectorAll('input[data-ic-prop]').forEach(function(n){ n.remove(); });
        var distParts = [];
        Object.keys(st).forEach(function(c){
          if (st[c] > 0){
            var hp = document.createElement('input');
            hp.type = 'hidden'; hp.name = 'properties[Color ' + c + ']'; hp.value = String(st[c]);
            hp.setAttribute('data-ic-prop','1');
            form.appendChild(hp);
            distParts.push(st[c] + '× ' + c);
          }
        });
        if (distParts.length){
          var dp = document.createElement('input');
          dp.type = 'hidden'; dp.name = 'properties[Distribución]'; dp.value = distParts.join(' · ');
          dp.setAttribute('data-ic-prop','1');
          form.appendChild(dp);
          var pp = document.createElement('input');
          pp.type = 'hidden'; pp.name = 'properties[Pack]'; pp.value = packVal;
          pp.setAttribute('data-ic-prop','1');
          form.appendChild(pp);
        }
      });
    }
    var prodSection = box.closest('.ic-product');
    var mainImg = prodSection ? prodSection.querySelector('.prod-img-main img') : null;
    colorBtns.forEach(function(el){
      el.addEventListener('click', function(){
        colorBtns.forEach(function(s){s.classList.remove('on');});
        el.classList.add('on');
        var lbl = box.querySelector('.color-lbl'); if(lbl) lbl.textContent = el.getAttribute('data-value');
        var im = el.getAttribute('data-img');
        if (im && mainImg){ mainImg.src = im; }
        state.color = el.getAttribute('data-value'); update();
      });
    });
    function updateDeposit(){
      var m = (state.pack || '').match(/\d+/g);
      var n = m ? parseInt(m[m.length-1], 10) : 0;
      var amt = n >= 50 ? '$40.000' : '$12.000';
      box.querySelectorAll('.pay-cod-amt').forEach(function(el){ el.textContent = amt; });
    }
    var mixState = {}; // { packValue: { ColorName: qty, ... } }
    function mixTotal(packVal){
      var m = mixState[packVal] || {};
      var t = 0; for (var k in m){ t += (m[k] || 0); }
      return t;
    }
    function getPackMax(el){
      if (el.classList.contains('bulk')){
        var inp = el.querySelector('.qty-inp');
        var n = inp ? parseInt(inp.value, 10) : 50;
        if (isNaN(n) || n < 50) n = 50;
        return n;
      }
      return parseInt(el.getAttribute('data-pack-qty'),10) || 0;
    }
    function mixUpdatePack(el){
      var packVal = el.getAttribute('data-value');
      var maxQ = getPackMax(el);
      var cur = mixTotal(packVal);
      var curEl = el.querySelector('[data-mix-current]'); if (curEl) curEl.textContent = String(cur);
      var maxEl = el.querySelector('[data-mix-max]'); if (maxEl) maxEl.textContent = String(maxQ);
      var hintEl = el.querySelector('[data-mix-hint]');
      if (hintEl){
        if (maxQ === 0){ hintEl.textContent = ''; }
        else if (cur === 0){ hintEl.textContent = 'Te faltan ' + maxQ + ' cajas por elegir'; }
        else if (cur < maxQ){ hintEl.textContent = 'Te falta(n) ' + (maxQ - cur) + ' caja(s) más'; }
        else if (cur > maxQ){ hintEl.textContent = 'Te excediste por ' + (cur - maxQ) + ' caja(s)'; }
        else { hintEl.textContent = '¡Listo! Pack completo.'; }
      }
      el.querySelectorAll('[data-mix-inc]').forEach(function(b){ b.disabled = cur >= maxQ; });
      el.dataset.mixComplete = (cur === maxQ && maxQ > 0) ? 'true' : 'false';
    }
    packItems.forEach(function(el){
      var isDetails = el.tagName === 'DETAILS';
      // accordion: when one opens, close others
      if (isDetails){
        el.addEventListener('toggle', function(){
          if (el.open){
            packItems.forEach(function(s){ if (s !== el && s.tagName === 'DETAILS' && s.open) s.open = false; });
            packItems.forEach(function(s){s.classList.remove('on');});
            el.classList.add('on');
            state.pack = el.getAttribute('data-value');
            if (el.classList.contains('bulk')){
              state.qty = bulkMinVal;
              if (qtyInput) qtyInput.value = bulkMinVal;
            } else {
              state.qty = 1;
            }
            update(); updateDeposit();
            mixUpdatePack(el);
          }
        });
      } else {
        el.addEventListener('click', function(e){
          if (e.target.closest('.pack-bulk-row')) return;
          packItems.forEach(function(s){s.classList.remove('on');});
          el.classList.add('on');
          state.pack = el.getAttribute('data-value');
          if (el.classList.contains('bulk')){
            state.qty = bulkMinVal;
            if (qtyInput) qtyInput.value = bulkMinVal;
          } else { state.qty = 1; }
          update(); updateDeposit();
        });
      }

      // bind +/- per color
      var packVal = el.getAttribute('data-value');
      el.querySelectorAll('.pack-mix-color').forEach(function(row){
        var color = row.getAttribute('data-color');
        if (!mixState[packVal]) mixState[packVal] = {};
        if (mixState[packVal][color] == null) mixState[packVal][color] = 0;
        var inp = row.querySelector('[data-mix-qty]');
        var inc = row.querySelector('[data-mix-inc]');
        var dec = row.querySelector('[data-mix-dec]');
        if (inc) inc.addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          var maxQ = parseInt(el.getAttribute('data-pack-qty'),10) || 0;
          if (mixTotal(packVal) >= maxQ) return;
          mixState[packVal][color]++;
          if (inp) inp.value = String(mixState[packVal][color]);
          mixUpdatePack(el); update();
        });
        if (dec) dec.addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          if (mixState[packVal][color] <= 0) return;
          mixState[packVal][color]--;
          if (inp) inp.value = String(mixState[packVal][color]);
          mixUpdatePack(el); update();
        });
      });
      mixUpdatePack(el);
    });

    // expose mix state for form submission
    box._icMixState = mixState;
    if (qtyInput){
      qtyInput.addEventListener('input', function(){
        var n = parseInt(qtyInput.value, 10);
        state.qty = isNaN(n) ? 0 : n;
        if (bulkItem) mixUpdatePack(bulkItem);
        update();
      });
      qtyInput.addEventListener('blur', function(){
        var n = parseInt(qtyInput.value, 10);
        if (isNaN(n) || n < bulkMinVal) n = bulkMinVal;
        state.qty = n; qtyInput.value = n;
        if (bulkItem) mixUpdatePack(bulkItem);
        update();
      });
    }
    box.querySelectorAll('.qty-btn').forEach(function(b){
      b.addEventListener('click', function(e){
        e.stopPropagation(); e.preventDefault();
        var n = state.qty || bulkMinVal;
        n = b.classList.contains('minus') ? n - 1 : n + 1;
        if (n < bulkMinVal) n = bulkMinVal;
        state.qty = n;
        if (qtyInput) qtyInput.value = n;
        if (bulkItem) mixUpdatePack(bulkItem);
        update();
      });
    });
    var payOpts = box.querySelectorAll('.pay-opt');
    payOpts.forEach(function(el){
      el.addEventListener('click', function(){
        payOpts.forEach(function(s){s.classList.remove('on'); s.setAttribute('aria-checked','false');});
        el.classList.add('on'); el.setAttribute('aria-checked','true');
      });
      el.addEventListener('keydown', function(e){
        if (e.key === ' ' || e.key === 'Enter'){ e.preventDefault(); el.click(); }
      });
    });
    update(); updateDeposit();
  }

  function initThumbNav(){
    document.querySelectorAll('.ic-product .thumbs-wrap').forEach(function(w){
      if (w.dataset.icBound) return;
      w.dataset.icBound = '1';
      var track = w.querySelector('.prod-thumbs');
      var prev = w.querySelector('.thumb-nav.prev');
      var next = w.querySelector('.thumb-nav.next');
      if (!track) return;
      function update(){
        var atStart = track.scrollLeft <= 4;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        var noOverflow = track.scrollWidth <= track.clientWidth + 4;
        if (prev) prev.classList.toggle('off', atStart || noOverflow);
        if (next) next.classList.toggle('off', atEnd || noOverflow);
      }
      if (prev) prev.addEventListener('click', function(){ track.scrollBy({left:-track.clientWidth*0.7, behavior:'smooth'}); });
      if (next) next.addEventListener('click', function(){ track.scrollBy({left: track.clientWidth*0.7, behavior:'smooth'}); });
      track.addEventListener('scroll', update, {passive:true});
      window.addEventListener('resize', update);
      update();
    });
  }

  function initAll(scope){
    initNav();
    initChalkBg();
    initChalkTrail();
    initReveal(scope);
    (document.querySelectorAll('.ic-buybox')).forEach(initBuyBox);
    initThumbNav();
  }

  /* delegated clicks: gallery + faq */
  document.addEventListener('click', function(e){
    var thumb = e.target.closest('.ic-product .pthumb');
    if (thumb){
      var vis = thumb.closest('.prod-vis');
      vis.querySelectorAll('.pthumb').forEach(function(t){ t.classList.remove('on'); });
      thumb.classList.add('on');
      var main = vis.querySelector('.prod-img-main img');
      if (main && thumb.getAttribute('data-full')) main.src = thumb.getAttribute('data-full');
      return;
    }
    var q = e.target.closest('.ic-faq .faq-q');
    if (q){
      var item = q.closest('.faq-item');
      var open = item.classList.contains('open');
      var list = item.closest('.faq-list');
      list.querySelectorAll('.faq-item.open').forEach(function(i){ i.classList.remove('open'); });
      if (!open) item.classList.add('open');
    }
  });

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
  } else { initAll(document); }

  /* Theme editor re-init */
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();
